import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Animira elemente unutar sekcije kada se scroll-uje do nje.
 * @param {string[]} selectors - CSS selektori elemenata koji se animiraju
 * @param {object}  options    - { start, end, scrub, stagger, y }
 * @returns {React.RefObject}   - ref koji se stavlja na <section>
 */
export function useScrollReveal(selectors = [], options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const section = ref.current;
    if (!section) return;

    const {
      start   = 'top 82%',
      end     = 'top 30%',
      scrub   = 0.9,
      stagger = 0.09,
      y       = 40,
    } = options;

    const els = selectors.flatMap(sel => Array.from(section.querySelectorAll(sel)));
    if (!els.length) return;

    gsap.set(els, { opacity: 0, y });

    const tl = gsap.timeline({
      scrollTrigger: { trigger: section, start, end, scrub },
    });

    els.forEach((el, i) => {
      tl.to(el, { opacity: 1, y: 0, duration: 0.35, ease: 'power2.out' }, i * stagger);
    });

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach(st => st.kill());
    };
  }, []);

  return ref;
}